import { render, staticRenderFns } from "./EditCoupon.vue?vue&type=template&id=4a71d708&scoped=true&"
import script from "./EditCoupon.vue?vue&type=script&lang=js&"
export * from "./EditCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71d708",
  null
  
)

export default component.exports